import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import {
  Button,
  Group,
  Indicator,
  LoadingOverlay,
  Modal,
  Select,
  Stack,
  Switch,
  Text,
  TextInput,
} from "@mantine/core";
import { IconEdit, IconFilter } from "@tabler/icons-react";
import { useLeadsStore } from "../../../../../../stores/LeadsStore";
import FilterContent from "../../../../../../components/Filter/FilterContent";
import { notifications } from "@mantine/notifications";
import PopOver from "../../../../../../components/View/PopOver";
import BackButton from "../../../../../../components/View/BackButton";
import { editCron } from "../../../../../../api/ConfigsApi";
import { useProfileStore } from "../../../../../../stores/UserStore";
import DatafieldsSelector from "../../../../../../components/Selectors/DatafieldsSelector";

const EditMake = ({ itemProfile, handleDone }) => {
  const lang = useLanguage((s) => s.language);
  let itemArgs = itemProfile.arguments;
  const [opened, setOpened] = useState(false);
  const [finding, setFinding] = useState(false);
  const [loading, setLoading] = useState(false);
  const filters = useLeadsStore((s) => s.filters);
  const [datafieldIds, setDatafieldsIds] = useState(itemArgs.datafield_ids);
  const [invalidUrl, setInvalidUrl] = useState(false);
  const profile = useProfileStore((s) => s.profile);

  const [filter, setFilter] = useState(itemArgs.contacts_selection?.filter);

  const handleOpen = () => {
    setOpened(true);
    setInvalidUrl(false);
  };
  const handleClose = () => {
    setOpened(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    let formData = new FormData(e.target);
    let data = Object.fromEntries(formData);    

    const args = {
      type: "prm_synchronise_with_make",
      prm_user_id: profile?.id,
      datafield_ids: datafieldIds,
      contacts_selection: {
        filter: filter || { mode: "or", values: [] },
        contact_ids: [],
        excluded_contact_ids: [],
      },
      hook_url: data.hook_url,
      resend_synchronized_contacts:
        data?.resend_synchronized_contacts === "on" ? false : true,
    };

    editCron({
      id: itemProfile.id,
      name: data?.name,
      frequency: data?.frequency,
      args,
    })
      .then((response) => {
        notifications.show({
          message: lang.sync_zapier.sync_edited,
          color: "tertiary.8",
        });
        handleClose();
        handleDone();
      })
      .catch((err) => {
        if (err.response.data.state_message === "cron_invalid_hook_url") {
          document.getElementById("new-webhook-url").focus();
          setInvalidUrl(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        leftSection={<IconEdit size={18} />}
        variant="light"
        ml={"auto"}
      >
        {lang.global.edit}
      </Button>

      <Modal
        opened={opened}
        title={lang.sync_zapier.edit_title + itemProfile.name}
        onClose={handleClose}
        size={"50%"}
      >
        <LoadingOverlay visible={finding} />
        <Stack
          component={"form"}
          onSubmit={onSubmit}
          key={itemProfile?.arguments ? "a" : "b"}
        >
          <Group wrap="nowrap">
            <TextInput
              name="name"
              defaultValue={itemProfile.name}
              label={lang.prm.nurturing.create_name}
              placeholder={lang.prm.nurturing.create_name}
              required
              w={"100%"}
              autoFocus
              data-autofocus
              size="md"
            />

            <Select
              name="frequency"
              defaultValue={itemProfile.frequency}
              label={lang.sync_zapier.event_label}
              placeholder={lang.sync_zapier.event_label}
              required
              data={Object.keys(lang.sync_zapier.frequency).map((x) => ({
                value: x,
                label: lang.sync_zapier.frequency[x],
              }))}
              size="md"
            />
          </Group>

          <DatafieldsSelector
            label={lang.contact_lists.cron.fields}
            placeholder={lang.contact_lists.cron.fields_placeholder}
            values={datafieldIds}
            onChange={(v) => setDatafieldsIds(v.map((x) => x.id))}
            zIndex={1700}
            withinPortal={false}
            size="md"
            required
          />

          <TextInput
            name="hook_url"
            label={lang.sync_zapier.hook_url}
            defaultValue={itemProfile?.arguments?.hook_url}
            id="new-webhook-url"
            type="url"
            placeholder="https://hook.eu2.make.com/abcdef"
            required
            error={invalidUrl}
            size="md"
          />

          <Switch
            label={lang.sync_zapier.ignore}
            defaultChecked={
              !itemProfile?.arguments?.resend_synchronized_contacts
            }
            name="resend_synchronized_contacts"
            size="md"
          />

          <PopOver
            opener={(openFunction, ref) => {
              return (
                <Button
                  ref={ref}
                  variant="default"
                  onClick={openFunction}
                  id={"make-filter-" + "creation"}
                  size="md"
                >
                  <Indicator
                    color="red"
                    offset={2}
                    disabled={filter?.items?.length === 0 || !filter}
                    label={filter?.items?.length}
                    size={12}
                  >
                    <IconFilter size={18} />
                  </Indicator>
                  <span style={{ marginLeft: 6 }}>
                    {lang.table.toolbar.filter.main_button_label} *
                  </span>
                </Button>
              );
            }}
            popoverChildren={(closePopover) => (
              <FilterContent
                fields={filters}
                id={"make-create"}
                isClient={false}
                pageName={"prm"}
                maxHeight={350}
                mainFilter={filter}
                setMainFilter={(v) => {
                  closePopover();
                  setFilter(v);
                }}
                defaultFiltersClose
                getFieldOptionName={(f) => f.option_name}
              />
            )}
            elevation={3}
          />

          <Group justify="end" mt={"lg"}>
            <BackButton onClick={handleClose} size="md" />
            <Button
              // disabled={
              //   type === "prm" ? !filter || filter?.values?.length === 0 : false
              // }
              leftSection={<IconEdit size={18} />}
              loading={loading}
              type="submit"
              size="md"
            >
              {lang.contact_lists.cron.edit}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default EditMake;
